"use client";

import type React from "react";
import { useMemo, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { COUNTRY_PHONE_MAP } from "@/lib/country-codes";

export default function LetsTalkForm() {
  const phoneCodes = useMemo(() => {
    const codes = Array.from(new Set(Object.values(COUNTRY_PHONE_MAP)));
    codes.sort((a, b) => parseInt(a.slice(1)) - parseInt(b.slice(1)));
    return codes;
  }, []);

  const [formData, setFormData] = useState({
    firstName: "",
    secondName: "",
    email: "",
    countryCode: "+91",
    mobile: "",
    description: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const payload = {
      ...formData,
      mobile: `${formData.countryCode}${formData.mobile}`,
    };

    console.log("MMI Form submitted:", payload);
  };

  return (
    <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
      {/* First + Second Name */}
      <div className="grid md:grid-cols-2 gap-3 md:gap-6">
        <div className="space-y-1 md:space-y-2">
          <label className="text-[11px] md:text-sm font-medium text-[var(--mmi-heading)]">
            First Name
          </label>
          <input
            type="text"
            placeholder="Enter your first name"
            value={formData.firstName}
            onChange={(e) =>
              setFormData({ ...formData, firstName: e.target.value })
            }
            className="w-full px-3 py-2 md:px-4 md:py-3 rounded-xl border-2 border-[var(--brand-yellow)]"
            required
          />
        </div>

        <div className="space-y-1 md:space-y-2">
          <label className="text-[11px] md:text-sm font-medium text-[var(--mmi-heading)]">
            Second Name
          </label>
          <input
            type="text"
            placeholder="Enter your second name"
            value={formData.secondName}
            onChange={(e) =>
              setFormData({ ...formData, secondName: e.target.value })
            }
            className="w-full px-3 py-2 md:px-4 md:py-3 rounded-xl border-2 border-[var(--brand-yellow)]"
          />
        </div>
      </div>

      {/* Email + Mobile */}
      <div className="grid md:grid-cols-2 gap-3 md:gap-6">
        {/* Email */}
        <div className="space-y-1 md:space-y-2">
          <label className="text-[11px] md:text-sm font-medium text-[var(--mmi-heading)]">
            Email Address
          </label>
          <input
            type="email"
            placeholder="Enter your email address"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
            className="w-full px-3 py-2 md:px-4 md:py-3 rounded-xl border-2 border-[var(--brand-yellow)]"
            required
          />
        </div>

        {/* Mobile Number */}
        <div className="space-y-1 md:space-y-2">
          <label className="text-[11px] md:text-sm font-medium text-[var(--mmi-heading)]">
            Mobile Number
          </label>

          <div className="flex items-center overflow-hidden rounded-xl border-2 border-[var(--brand-yellow)]">
            <Select
              value={formData.countryCode}
              onValueChange={(val) =>
                setFormData({ ...formData, countryCode: val })
              }
            >
              <SelectTrigger className="w-[84px] md:w-[96px] border-r-2 border-[var(--brand-yellow)]">
                <SelectValue />
              </SelectTrigger>

              <SelectContent className="max-h-56 overflow-auto">
                {phoneCodes.map((code) => (
                  <SelectItem key={code} value={code}>
                    {code}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            <input
              type="tel"
              placeholder="Enter your number"
              value={formData.mobile}
              onChange={(e) =>
                setFormData({ ...formData, mobile: e.target.value })
              }
              className="flex-1 px-3 py-2 focus:outline-none"
            />
          </div>
        </div>
      </div>

      {/* Description */}
      <div className="space-y-1 md:space-y-2">
        <label className="text-[11px] md:text-sm font-medium text-[var(--mmi-heading)]">
          Description
        </label>
        <textarea
          placeholder="Enter your description in detail"
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          rows={5}
          className="w-full px-3 py-2 md:px-4 md:py-3 rounded-xl border-2 border-[var(--brand-yellow)] resize-none"
          required
        />
      </div>

      {/* Submit */}
      <Button
        type="submit"
        className="bg-[var(--brand-yellow)] rounded-full px-8 py-4 font-semibold"
      >
        Submit
      </Button>
    </form>
  );
}
